export default __webpack_public_path__ + "static/media/dash.5425f45a.webp";